import { CopyOutlined } from '@ant-design/icons';
import { Button, Modal, message } from 'antd';
import style from "css/meetinglog.module.css";
import { useTranslation } from 'react-i18next';

// props: isOpen, close, data
function Meetingpop(props) {

    const { t } = useTranslation();

    const [messageApi, contextHolder] = message.useMessage();

    const handleCopyClipBoard = async (copyURL, recTitle) => {
        try {
            await navigator.clipboard.writeText(copyURL);
            messageApi.open({
                type: 'success',
                content: t("MESSAGE.LINK_COPY_COMPLETE", { TITLE: recTitle }),
            });
        } catch (e) {
            messageApi.open({
                type: 'error',
                content: t("MESSAGE.LINK_COPY_FAIL"),
            });
        }
    };
    return (
        <Modal
            open={props.isOpen}
            // onOk={props.close}
            onCancel={props.close}
            centered
            okButtonProps={{
                // disabled: true,
                type: 'primary'
            }}
            // okText='확인'
            footer={[
                <Button key="ok" type='primary' onClick={props.close} >
                    {t("BTN.OK")}
                </Button>
            ]}
        >
            {contextHolder}
            <div className={style.pop_container}>
                <div className={style.pop_header}>
                    <div>{t("LABEL.TITLE.HYBRID_WORKING")}</div>
                </div>
                <div className={style.pop_body}>
                    {/* <div className={style.pop_platform}>
                        {props.data.SCHEDULE_TYPE}
                    </div> */}
                    <div className={style.pop_infolist}>
                        <div className={style.pop_info}>
                            <span className={style.pop_infotitle}>{t("LIST.MEETING_RECORDING")}</span>
                            <span className={style.pop_infocontent}>
                                {props.data.RECORD_YN === 'Y' ? 'ON' : 'OFF'}
                            </span>
                        </div>
                        <div className={style.pop_info}>
                            <span className={style.pop_infotitle}>{t("LIST.MEETING_START")}</span>
                            <span className={style.pop_infocontent}>{props.data.START_TIME}</span>
                        </div>
                        <div className={style.pop_info}>
                            <span className={style.pop_infotitle}>{t("LIST.MEETING_END")}</span>
                            <span className={style.pop_infocontent}>{props.data.END_TIME}</span>
                        </div>
                        <div className={style.pop_info}>
                            <span className={style.pop_infotitle}>{t("LIST.MEETING_HOST")}</span>
                            <span className={style.pop_infocontent}>{props.data.HOST_NM}</span>
                        </div>
                        <div className={style.pop_info}>
                            <span className={style.pop_infotitle}>{t("LIST.MEETING_ROOM")}</span>
                            <span className={style.pop_infocontent}>
                                {
                                    props.data.ENDPOINTS.length === 0
                                        ? "-"
                                        : props.data.ENDPOINTS.map((el, idx) => (
                                            idx === 0
                                                ? <span key={idx}>{el}</span>
                                                : <span key={idx}>{", " + el}</span>
                                        ))
                                }
                            </span>
                        </div>
                        <div className={style.pop_info}>
                            <span className={style.pop_infotitle}>{t("LIST.PARTICIPANT")}</span>
                            <span className={style.pop_infocontent}>
                                {
                                    props.data.PARTICIPANTS.length === 0
                                        ? "-"
                                        : props.data.PARTICIPANTS.map((el, idx) => (
                                            idx === 0
                                                ? <span key={idx}>{el}</span>
                                                : <span key={idx}>{", " + el}</span>
                                        ))
                                }
                            </span>
                        </div>
                        <div className={style.pop_info}>
                            <span className={style.pop_infotitle}>{t("LABEL.MEETING_CONTENT")}</span>
                            <span className={style.pop_infocontent}>
                                {
                                    props.data.CONTENTS !== '' && props.data.CONTENTS !== null
                                        ? props.data.CONTENTS
                                        : '-'
                                }
                            </span>
                        </div>
                    </div>
                </div>
                {props.data.MEETING_URL !== '' && props.data.MEETING_URL !== undefined
                    ?
                    <div className={style.pop_urlarea}>
                        <label htmlFor='url_copy'>
                            <div className={`${style.pop_urlbox} cursor`}>
                                <span>{props.data.MEETING_URL}</span>
                                <Button
                                    id='url_copy'
                                    type='ghost'
                                    onClick={() => {
                                        handleCopyClipBoard(props.data.MEETING_URL, props.data.TITLE);
                                    }}
                                >
                                    <CopyOutlined className={style.pop_copyicon} />
                                </Button>
                            </div>
                        </label>
                        <div className={style.url_msg}>
                            <span>{t("LABEL.COPY_LINK_SHARE_ROOM")}</span>
                        </div>
                    </div>
                    : <></>
                }

            </div>
        </Modal >
    )
}

export default Meetingpop
